<div class="card proyecto-modal">
  <header class="card-header card-header-primary proyecto-modal__header">
    <div class="proyecto-modal__header-copy">
      <h4 class="card-title"><b>{{ tituloModal }}</b></h4>
      <p class="card-category" *ngIf="tituloModal === 'Agregar Proyecto'">
        Registra la información principal del proyecto y su avance inicial.
      </p>
      <p class="card-category" *ngIf="tituloModal !== 'Agregar Proyecto'">
        Actualiza el avance real y agrega un comentario de seguimiento.
      </p>
    </div>
    <button mat-icon-button type="button" class="proyecto-modal__close" aria-label="Cerrar" (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </header>

  <div class="card-body proyecto-modal__body">
    <form [formGroup]="formGroupProject" class="proyecto-modal__form" autocomplete="off">
      <section class="proyecto-modal__fields proyecto-modal__fields--identity">
        <mat-form-field>
          <mat-label>Nombre del proyecto</mat-label>
          <input matInput #inputNameProject type="text" [(ngModel)]="proyecto.nombre" formControlName="nameProjectCtrl"
            maxlength="150" [readonly]="proyecto.nombre != null" aria-label="Nombre del proyecto"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Nombre corto</mat-label>
          <input matInput type="text" [(ngModel)]="proyecto.nombre_corto" formControlName="nameProjectShortCtrl"
            maxlength="45" [readonly]="proyecto.nombre_corto != null" aria-label="Nombre corto"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Área</mat-label>
          <mat-select [(ngModel)]="proyecto.idArea" formControlName="areaProjectCtrl"
            [disabled]="proyecto.idArea !== null">
            <mat-option *ngFor="let areaObject of listArea" [value]="areaObject.id">
              {{ areaObject.area }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </section>

      <section class="proyecto-modal__fields proyecto-modal__fields--schedule">
        <mat-form-field>
          <mat-label>Cliente</mat-label>
          <mat-select [(ngModel)]="proyecto.idCliente" formControlName="customerCtrl" disabled>
            <mat-option *ngFor="let cliente of clientes" [value]="cliente.id">
              {{ cliente.razonsocial }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Fecha de inicio</mat-label>
          <input matInput [value]="proyecto.fechaInicio ? (proyecto.fechaInicio | date : 'dd/MM/yyyy') : ''" readonly
            aria-label="Fecha de inicio" />
          <mat-icon matSuffix>calendar_today</mat-icon>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Fecha de fin</mat-label>
          <input matInput [value]="proyecto.fechaFin ? (proyecto.fechaFin | date : 'dd/MM/yyyy') : ''" readonly
            aria-label="Fecha de fin" />
          <mat-icon matSuffix>calendar_today</mat-icon>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Avance real (%)</mat-label>
          <input matInput type="number" [(ngModel)]="proyecto.avanceReal" formControlName="avanceReal" min="0" max="100"
            soloNumeroEntero aria-label="Avance real (%)" />
        </mat-form-field>
      </section>

      <section class="proyecto-modal__fields proyecto-modal__fields--full">
        <mat-form-field>
          <mat-label>Descripción</mat-label>
          <textarea matInput rows="4" maxlength="500" [(ngModel)]="proyecto.descripcion"
            formControlName="descriptionProjectCtrl" [readonly]="proyecto.descripcion != null" aria-label="Descripción"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
        </mat-form-field>
      </section>

      <section class="proyecto-modal__fields proyecto-modal__fields--full">
        <mat-form-field>
          <mat-label>Comentarios</mat-label>
          <textarea matInput rows="4" maxlength="500" formControlName="comentarios"
            placeholder="Escribe un nuevo comentario" aria-label="Comentarios"></textarea>
        </mat-form-field>
      </section>

      <footer mat-dialog-actions class="proyecto-modal__actions">
        <button mat-button type="button" class="btn btn-danger" (click)="onNoClick()">
          <i class="fa fa-times-circle-o"></i> Cancelar
        </button>
        <button mat-button type="button" class="btn btn-success" (click)="save()" [disabled]="!formGroupProject.valid">
          Guardar <i class="material-icons">save</i>
        </button>
      </footer>
    </form>
  </div>
</div>
